import { FC, useMemo } from "react"
import { RateFlowDetails } from "../../../../../../../../types"
import {
  LOMap,
  PricingEngineType,
  ENGINES_WITH_LO_MAP
} from "../../../../../../../../types/pricing-engine"
import { useFetchLoanOfficersQuery } from "../../../../../../../../redux/queries"
import LOMapManager from "../../../../../../pricing-engine/lo-map-manager"
import OBLOMapManager from "../../../../../../pricing-engine/lo-map-manager/ob-lo-map-manager"

interface Props {
  values: RateFlowDetails
  setFormField: (name: string, value: any) => void
}

const RateflowLoMap: FC<Props> = ({ values, setFormField }) => {
  const engineType = (
    values.settings?.api_mode === "ob"
      ? "optimal_blue"
      : values.settings?.api_mode || undefined
  ) as PricingEngineType | undefined

  const { data: membersData } = useFetchLoanOfficersQuery(
    { brand_id: values.bank_id },
    { skip: !values.bank_id }
  )
  const members = useMemo(() => membersData?.los || [], [membersData])

  const currentLoMap: LOMap = values.settings?.lo_map || {}

  const handleChange = (newLoMap: LOMap) =>
    setFormField("settings", { ...values.settings, lo_map: newLoMap })

  if (!engineType) {
    return (
      <div className="mt-4 rounded-md bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-800">
        Select a pricing engine on the <strong>Pricing Engine</strong> tab
        first.
      </div>
    )
  }

  if (!ENGINES_WITH_LO_MAP.includes(engineType)) {
    return (
      <div className="mt-4 rounded-md bg-gray-50 border border-gray-200 px-4 py-3 text-sm text-gray-600">
        LO mapping is not supported for this engine.
      </div>
    )
  }

  if (engineType === "optimal_blue") {
    return (
      <OBLOMapManager
        rateflowId={values.id || ""}
        brandId={values.bank_id}
        currentLoMap={currentLoMap}
        members={members}
        onChange={handleChange}
        engineType={engineType}
      />
    )
  }

  return (
    <LOMapManager
      currentLoMap={currentLoMap}
      members={members}
      onChange={handleChange}
      engineType={engineType}
    />
  )
}

export default RateflowLoMap
